// global window
declare global {
  interface Window {
    _wq: any;
    Wistia: any;
  }
}

export const WISTIA_SCRIPT_URL = '//fast.wistia.net/assets/external/E-v1.js';
